import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="accordion-image"
export default class extends Controller {
  static targets = ["imageContainer", "collapse"]

  connect() {
    this.setDefaultImage()

    this.collapseTargets.forEach(collapseEl => {
      collapseEl.addEventListener('shown.bs.collapse', this.updateImage.bind(this))
    })
  }

  disconnect() {
    this.collapseTargets.forEach(collapseEl => {
      collapseEl.removeEventListener('shown.bs.collapse', this.updateImage.bind(this))
    })
  }

  setDefaultImage() {
    const firstCollapse = this.collapseTargets[0];
    if (firstCollapse && firstCollapse.classList.contains('show')) {
       const imagePath = firstCollapse.dataset.imagePath;
       if (imagePath) {
         this.imageContainerTarget.innerHTML = `<img src="${imagePath}" alt="Accordion Image" class="img-fluid">`;
       }
    }
  }

  updateImage(event) {
    const imagePath = event.target.dataset.imagePath;
    if (imagePath) {
      this.imageContainerTarget.innerHTML = `<img src="${imagePath}" alt="Accordion Image" class="img-fluid">`;
    } else {
      this.imageContainerTarget.innerHTML = '';
      console.warn("No image path found for this accordion item:", event.target);
    }
  }
}